import { Alert } from "@mui/material";

import Body from "../../../components/theme/Body";
import Button from "../../../components/theme/Button";
import useFetch from "../../../hooks/useFetch";
import { formatPrice } from "../../../lib/format";
import { Step } from "../show";

import FeedbackStep from "./FeedbackStep";

const PaymentStep: Step = ({ details, setStep }) => {
  const { actual_price, iban, iban_name, price } = details;
  const [put, { error, loading }] = useFetch(window.location.href, {
    method: "PUT",
    onSuccess: () => setStep(FeedbackStep),
  });

  return (
    <>
      <Body marginBottom="1em" maxWidth={800}>
        Gebruik onderstaande gegevens om de reiskosten over te maken via jouw
        bank.
      </Body>
      <Body
        marginBottom="1em"
        maxWidth={800}
        sx={{ "& th": { textAlign: "left", paddingRight: "1em" } }}
      >
        <table>
          <tr>
            <th>Bedrag</th>
            <td>
              {formatPrice(actual_price ?? 0)}
              {actual_price !== price &&
                ` (in plaats van de geschatte ${formatPrice(price ?? 0)})`}
            </td>
          </tr>
          <tr>
            <th>IBAN</th>
            <td>{iban}</td>
          </tr>
          <tr>
            <th>Op naam van</th>
            <td>{iban_name}</td>
          </tr>
        </table>
      </Body>
      <Button
        loading={loading}
        sx={{ marginTop: "1em" }}
        type="button"
        variant="contained"
        onClick={() => put()}
      >
        Het geld is overgemaakt
      </Button>
      {error && (
        <Alert severity="error" sx={{ marginTop: "1em" }}>
          {error}
        </Alert>
      )}
    </>
  );
};

export default PaymentStep;
